import React from 'react'
import { Link } from 'gatsby'

import Modal from './Modal/Modal'

import {
  Container,
  Content,
  LinksDiv,
  ColDiv
} from '../styles/hamburgerModal.styles'

export default function HamburgerModal(props) {
  return (
    <>
      <Modal id="portal" exitCallback={props.exitCallback}>
        <Container>
          <Content>
            <LinksDiv>
              <div>
                <a
                  onClick={() => {
                    props.openSearchModal()
                  }}
                >
                  <i className="fas fa-search"></i>
                </a>
              </div>
              <Link to="/computing/" onClick={props.exitCallback}>
                Computing
              </Link>
              <Link to="/gaming/" onClick={props.exitCallback}>
                Gaming
              </Link>
              <Link to="/productivity/" onClick={props.exitCallback}>
                Productivity
              </Link>
              <Link to="/vehicles/" onClick={props.exitCallback}>
                Vehicles
              </Link>
              <div>
                <a
                  href="https://twitter.com/ElektrikSpark"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-twitter"></i>
                </a>
                <a
                  href="https://facebook.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-facebook"></i>
                </a>
                <a
                  href="https://instagram.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-instagram"></i>
                </a>
                <a
                  href="https://linkedin.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-linkedin"></i>
                </a>
                <a
                  href="https://youtube.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-youtube"></i>
                </a>
              </div>
            </LinksDiv>
            <ColDiv>
              <h2>Get Involved</h2>
              <p>
                Connect with thousands of other TechBlog readers in our online
                community.
              </p>
              <button>Join our Discord Server!</button>
            </ColDiv>
          </Content>
        </Container>
      </Modal>
    </>
  )
}
